// extracted by mini-css-extract-plugin
export default {"Box":"filter-input-actions-module__Box__QktfpGc","Box_1":"filter-input-actions-module__Box_1__oM2XUy9"};